import script from "./UploadSpv.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSpv.vue?vue&type=script&setup=true&lang=js"

import "./UploadSpv.vue?vue&type=style&index=0&id=6d6a527e&lang=scss"

const __exports__ = script;

export default __exports__